// removed by extract-text-webpack-plugin
module.exports = {"BoxOne":"_26AnJ","BoxTwo":"_vK-BH","Timing":"_C6NhM","Cities":"_PEbTL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/InternationalTupleRoundTrip/InternationalTupleDetails/InternationalTupleDetails.scss
// module id = 841
// module chunks = 0